/**
 * DOM Utilities
 * @description DOM 조작을 위한 유틸리티 함수
 */

/**
 * 단일 요소 선택
 */
export const $ = <T extends Element = Element>(selector: string, parent: ParentNode = document): T | null => {
  return parent.querySelector<T>(selector);
};

/**
 * 복수 요소 선택
 */
export const $$ = <T extends Element = Element>(selector: string, parent: ParentNode = document): T[] => {
  return Array.from(parent.querySelectorAll<T>(selector));
};

/**
 * 에디터 캔버스 여부 판별 — body.nde-page 클래스 기반
 */
export const isEditorCanvas = (): boolean => document.body.classList.contains('nde-page');

/**
 * 헤더 속성 조회
 */
export interface HeaderAttributes {
  upperMenuType: 'category' | 'hamburger' | null;
  categoryType: 'sub' | 'all' | null;
}

export const getHeaderAttributes = (): HeaderAttributes => {
  const header = $<HTMLElement>('.js-main-header');

  return {
    upperMenuType: header?.getAttribute('data-upper-menu-type') as HeaderAttributes['upperMenuType'],
    categoryType: header?.getAttribute('data-upper-menu-category-type') as HeaderAttributes['categoryType'],
  };
};
